var fails = require('../internals/fails');

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/descriptors.js
// module id = 134
// module chunks = 0